import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

import { ClassNameComponent } from '@/utils/ClassNameComponent';
import ResourceIcon from '@/components/_deprecated/lessons/resource/ResourceIcon';
import ResourceTitleForm from './form/ResourceTitleForm';
import { ResourcePreview } from './ResourcePreview';
import ChangeResourceButton from './ChangeResourceButton';
import ModalEditResource from './form/ModalEditResource';
import ModalRemoveResource from './ModalRemoveResource';
import ResourceUploadProgress from './ResourceUploadProgress';
import ViewResourceButton from './ViewResourceButton';
import EditResourceButton from './EditResourceButton';
import RemoveResourceButton from './RemoveResourceButton';
import ResourceActivities from './lesson/ResourceActivities';
import ResourceMandatoryCheckbox from './form/ResourceMandatoryCheckbox';
import ResourceOnlyTeacherCheckbox from './form/ResourceOnlyTeacherCheckbox';

type ResourceCardProps = PropsWithChildren & {
  disabled?: boolean;
  className?: Pick<ClassNameComponent, 'base'>;
};

export default function ResourceCard(props: ResourceCardProps) {
  const { disabled, className, children } = props;
  return (
    <li
      className={twMerge(
        'flex flex-col w-full h-full border border-neutral-content shadow-xs rounded-lg bg-base-100 gap-2.5 p-2.5 relative',
        disabled ? 'disabled pointer-events-none' : '',
        className?.base,
      )}
    >
      {children}
    </li>
  );
}

ResourceCard.ModalRemove = ModalRemoveResource;
ResourceCard.Icon = ResourceIcon;
ResourceCard.Title = ResourceTitleForm;
ResourceCard.Preview = ResourcePreview;
ResourceCard.ChangeButton = ChangeResourceButton;
ResourceCard.ModalEdit = ModalEditResource;
ResourceCard.UploadProgress = ResourceUploadProgress;
ResourceCard.ViewButton = ViewResourceButton;
ResourceCard.EditButton = EditResourceButton;
ResourceCard.RemoveButton = RemoveResourceButton;
ResourceCard.Activities = ResourceActivities;
ResourceCard.MandatoryCheckbox = ResourceMandatoryCheckbox;
ResourceCard.OnlyTeacherCheckbox = ResourceOnlyTeacherCheckbox;
